// styles
import styles from '../picto.module.scss';

// components
import { Image } from 'components/image/image';
import { InnerHtml } from 'components/InnerHtml/inner-html';
import { InlineEdit } from 'components/ContentCreator/InlineEdit';

// utils
import { useIsMobile } from 'components/App/SizeProvider';
import { responsiveImage } from 'utils/responsiveImage';
import { decodingContent } from 'utils/decodingContent';

type PictoItemProps = {
  headline: string;
  description: string;
  imageObject: ImageObject;
  imageAlt: string;
  imageObjectMobile: ImageObjectMobile;
  reducedMobileVersion: boolean;
};

export function PictoItem({
  headline = '',
  description = '',
  imageObject,
  imageAlt,
  imageObjectMobile,
  reducedMobileVersion = false,
}: Readonly<PictoItemProps>) {
  const isMobile = useIsMobile();
  const image = responsiveImage(isMobile, imageObjectMobile, imageObject);

  return (
    <div className="small-12 cell">
      <div className={styles.content}>
        <div className={styles.iconWrapper}>
          <Image data={image} alt={imageAlt} title={imageAlt} />
        </div>
        {headline && (
          <b>
            <InlineEdit previewId="#st_headline">{decodingContent(headline)}</InlineEdit>
          </b>
        )}
        {description && !(isMobile && reducedMobileVersion) && (
          <InnerHtml as="p" content={description} />
        )}
      </div>
    </div>
  );
}
